import React from 'react';

import InventoryStructuredTableMode from 'notebook/integrations/samples/InventoryStructuredTableMode';
import FormGroup from 'ui-library/bs/FormGroup';
import RadioButtonGroup from 'ui-library/inputs/RadioButtonGroup';

export type InventoryTableInsertionMode = keyof typeof InventoryStructuredTableMode;

const INSERTION_MODE_FRIENDLY_NAME: {[k in InventoryTableInsertionMode]: string} = {
  [InventoryStructuredTableMode.CREATE]: 'Create and fill new containers',
  [InventoryStructuredTableMode.FILL]: 'Fill existing containers or plates',
  [InventoryStructuredTableMode.LEGACY_TRANSFER]: 'Create or fill containers',
  [InventoryStructuredTableMode.UPDATE_CONTAINERS]: 'Update container or plate well attributes',
};

const INSERTION_MODE_DATA_TEST_KEY: {[k in InventoryTableInsertionMode]: string} = {
  [InventoryStructuredTableMode.CREATE]: 'create',
  [InventoryStructuredTableMode.FILL]: 'fill',
  [InventoryStructuredTableMode.LEGACY_TRANSFER]: 'legacyTransfer',
  [InventoryStructuredTableMode.UPDATE_CONTAINERS]: 'updateContainers',
};

export default function InventoryTableInsertionModeToggle({
  currentMode,
  setMode,
  includeInsertionModes,
}: {
  currentMode: InventoryTableInsertionMode;
  setMode: (newMode: InventoryTableInsertionMode) => void;
  includeInsertionModes: Array<InventoryTableInsertionMode>;
}): JSX.Element {
  return (
    <FormGroup dataTestAttrs={{component: 'InventoryTableInsertionModeToggle', element: 'optionGroup'}}>
      <RadioButtonGroup
        title="Action"
        options={Object.keys(INSERTION_MODE_FRIENDLY_NAME)
          .filter((mode: InventoryTableInsertionMode) => includeInsertionModes.includes(mode))
          .map((mode: InventoryTableInsertionMode) => ({
            value: mode,
            label: INSERTION_MODE_FRIENDLY_NAME[mode],
            dataTestAttrs: {
              component: 'InventoryTableInsertionModeToggle',
              element: 'option',
              key: INSERTION_MODE_DATA_TEST_KEY[mode],
            },
          }))}
        onChange={setMode}
        selectedValue={currentMode}
        isVertical={true}
      />
    </FormGroup>
  );
}
